import { render, staticRenderFns } from "./SettingsNotificationSmtp.vue?vue&type=template&id=48c80301&"
import script from "./SettingsNotificationSmtp.vue?vue&type=script&lang=ts&"
export * from "./SettingsNotificationSmtp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports